/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { DocumentFormatCardIcon } from "cms/documents/document-selector/dialog/document-select-card/layout/";
import { Logger } from "cms/utils/log/logger";

const DocumentSelectCard = (props) => {

    const {
        document: guid,
        onClick,
        children
    } = props || {};
    const { token } = useAuth();
    const [documentGuid, setDocumentGuid] = useState();
    const [document, setDocument] = useState();
    const onClickHandler = async (event, document) => {
        if (typeof onClick === "function") {
            onClick(event, document);
        }
    };

    useEffect(() => {
        const fetchDocument = async () => {
            if (guid && documentGuid !== guid) {
                let current_doc = await SimpliCityAdminSDK.documents.findOne(token, guid);
                if (current_doc && current_doc.guid) {
                    setDocument(current_doc);
                    setDocumentGuid(current_doc.guid);
                    // Logger.debug('setDocument', current_doc)
                } else {
                    Logger.debug("Could not load document...", guid);
                }
            } else {
                setDocument(undefined);
            }
        };
        fetchDocument();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    return (
        <Fragment>
            <DocumentFormatCardIcon
                document={document}
                onClickHandler={onClickHandler}
            >
                <div className='document-select-card-box'>
                    {/* children is badge overlay */}
                    {children}
                </div>
            </DocumentFormatCardIcon>
        </Fragment>
    );
};
export { DocumentSelectCard };
